import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';

@Injectable({ providedIn: 'root' })
export class TelephonyHelperService {
  checkMicrophone() {
    return new Promise((resolve, reject) => {
      navigator.getUserMedia(
        {
          audio: true,
        },
        () => {
          resolve(true);
        },
        (error: any) => {
          resolve(false);
        }
      );
    });
  }
  async retry(fn: any, maxAttempts: any) {
    const delay = (fn: any, ms: any) => new Promise((resolve) => setTimeout(() => resolve(fn()), ms));
    const randInt = (min: any, max: any) => Math.floor(Math.random() * (max - min + 1) + min);
    const execute = async (attempt: any) => {
      try {
        return await fn();
      } catch (err) {
        if (attempt <= maxAttempts) {
          const nextAttempt = attempt + 1;
          const delayInSeconds = Math.max(
            Math.min(Math.pow(2, nextAttempt) + randInt(-nextAttempt, nextAttempt), 600),
            1
          );
          console.error(`Retrying after ${delayInSeconds} seconds due to:`, err);
          return delay(() => execute(nextAttempt), delayInSeconds * 1000);
        } else {
          throw err;
        }
      }
    };
    return execute(1);
  }
  playIncomingCallAudio() {
    try {
      if (document.getElementById('incoming-audio-player')) {
        return;
      }
      const audio = document.createElement('audio');
      audio.id = 'incoming-audio-player';
      audio.preload = 'none';
      audio.loop = true;
      audio.src = `/assets/audio/incoming.mp3`;
      document.body.appendChild(audio);
      audio.play();
    } catch (e) {
      console.log(e);
    }
  }
  pauseIncomingCallAudio() {
    try {
      const audioPlayer = document.getElementById('incoming-audio-player');
      if (!audioPlayer) {
        return;
      }
      audioPlayer.remove();
    } catch (e) {
      console.log(e);
    }
  }
  playAudio = (file: string) => {
    try {
      const audio = new Audio(`assets/softphone/sounds/${file}.mp3`);
      audio.play();
    } catch (e) {

    }
  };
}
